import React from "react";
import { Spin, Select } from "antd";

import { compose, config } from "src/helpers";
import { Field, RenderSelect } from "src/components";

import { withWorksheets } from "src/modules/worksheet/operations";

import { withStateAndActionsForWorksheet } from "../../resolvers";

const Option = Select.Option;

const SubjectsField = (props) => {
    const { loading, worksheets, where, onNameChange, onChange, value } = props;

    return (
        <Field
            labelInValue
            showSearch={true}
            filterOption={false}
            onSearch={onNameChange}
            notFoundContent={loading ? <Spin size="small" /> : null}
            name={"worksheets"}
            component={RenderSelect}
            placeholder={"Worksheets"}
            label={"Worksheets"}
            value={value || "None"}
            loading={loading}
            onChange={onChange}
            inFilter={true}
            noBotMarging={true}
        >
            {[
                // config.EMPTY_OPTION,
                ...(worksheets?.map((worksheet) => ({
                    id: worksheet.id,
                    label: worksheet.name || "",
                    value: JSON.stringify(worksheet),
                })) || []),
            ]?.map(
                ({
                    id,
                    value,
                    label = "",
                }: {
                    id: string;
                    value: string;
                    label: string;
                }) => (
                    <Option key={id} value={value}>
                        {label}
                    </Option>
                ),
            )}
        </Field>
    );
};

export default compose(
    withStateAndActionsForWorksheet,
    withWorksheets,
)(SubjectsField);
